import {
  EXPERTISES,
  EXPERTISE_FIELD,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import {
  ExpertiseState,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { judgementAddConstraints } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/validator';
import validate, { validateFormFields } from 'containers/services/validateForm';
import { ExpertiseTypes } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/typings';
import { get, isEmpty } from 'lodash';

export const judgementAddPronouncingValidator = (
  judgementAdd: JudgementADDDocumentType,
) => {
  return validate(judgementAdd, judgementAddConstraints());
};

export const shouldValidateExpertise = (expertise: ExpertiseState) => {
  let validationFields: Set<number> = new Set();

  const selectedExpertise = String(expertise[EXPERTISE_FIELD.EXPERTISE_ID]);
  if (!isEmpty(Array.from(get(expertise, 'expertises')))) {
    return !isEmpty(
      Array.from(get(expertise, 'expertises')).filter(
        (el: any) => !el.isDeleted,
      ),
    );
  } else {
    switch (selectedExpertise as ExpertiseTypes) {
      case EXPERTISES.MEDICAL:
        validationFields = expertise.victims;
        break;
      case EXPERTISES.MECHANICAL:
        validationFields = expertise.vehicules;
        break;
      case EXPERTISES.ACCOUNTING:
        validationFields = new Set([
          ...expertise.victims,
          ...expertise.vehicules,
        ]);
        break;
    }
    return validationFields.size > 0;
  }
};

export const expertiseValidation = { shouldValidateExpertise };

export const shouldValidateJudgementPronouncing = (
  judgementAddDocument: JudgementADDDocumentType,
  expertises: ExpertiseState[],
) => {
  const areExpertisesNotValidated = expertises.some(
    e => !expertiseValidation.shouldValidateExpertise(e),
  );

  const isJudgementDateValid =
    get(judgementAddDocument, 'judgementDate', null) !== 'Invalid date';

  const isFormValidated = validateFormFields(
    judgementAddPronouncingValidator(judgementAddDocument),
  );

  return isFormValidated && !areExpertisesNotValidated && isJudgementDateValid;
};
